import React from 'react';
import { usePhoneFlow } from '../AddPhone/usePhoneFlow';
import { PhoneFlowResult } from '../AddPhone/context';
import { useEmailFlow } from '../AddEmail/useEmailFlow';
import { EmailFlowResult } from '../AddEmail/context';
import { useEmailAndPhoneFlow } from '../AddEmailAndPhone/useEmailAndPhoneFlow';
import { EmailAndPhoneFlowResult } from '../AddEmailAndPhone/context';
import { FlowTypes } from './enums/FlowTypes';

const useGetFlowValues = (
  type: FlowTypes,
): PhoneFlowResult | EmailFlowResult | EmailAndPhoneFlowResult => {
  const phoneFlow = usePhoneFlow();
  const emailFlow = useEmailFlow();
  const emailAndPhoneFlow = useEmailAndPhoneFlow();

  const getFlow = React.useCallback(():
    | PhoneFlowResult
    | EmailFlowResult
    | EmailAndPhoneFlowResult => {
    if (type === FlowTypes.CELLPHONE) {
      return { ...phoneFlow };
    }

    if (type === FlowTypes.EMAIL) {
      return { ...emailFlow };
    }

    return { ...emailAndPhoneFlow };
  }, [type, emailAndPhoneFlow, emailFlow, phoneFlow]);

  return getFlow();
};

export { useGetFlowValues };
